import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function(){

    // get hp hero
    const hpHero = document.querySelector('.hp-hero');

    if ( !hpHero ) return;

    const resizeObserver = new ResizeObserver(entries => {
        // when ribbon height changes, set the new height to hero wrapper
        const newHeight = entries[0].contentRect.height;
        hpHero.style.setProperty('--ribbon-height', `${newHeight}px`);
    });

    // start observing hero ribbon size changes
    resizeObserver.observe(hpHero.querySelector('.hp-hero__ribbon'));


    // set up swiper
    const swiperEl = hpHero.querySelector('.hero-swiper');

    const swiper = new Swiper(swiperEl, {
        modules: [Pagination, EffectFade, Autoplay],
        autoplay: {
            delay: 6000,
            pauseOnMouseEnter: true,
        },
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });
});